import { Component, OnInit } from '@angular/core'
import { MatCard } from '@angular/material/card'
import { MatProgressBar } from '@angular/material/progress-bar'
import { MatDialog } from '@angular/material/dialog'
import { MatPaginatorModule, PageEvent } from '@angular/material/paginator'
import { TableListComponent } from '../../../shared/components/table-list/table-list.component'
import { FormClientSearchComponent } from '../../../shared/components/form-client-search/form-search.component'
import { AuthService } from '../../../core/services/auth/auth.service'
import { CoordinatorService } from '../../../core/services/coordinator/coordinator.service'
import { CoordinatorCreateComponent } from '../../../features/coordinator/coordinator-create/coordinator-create.component'
import { CoordinatorEditComponent } from '../../../features/coordinator/coordinator-edit/coordinator-edit.component'
import { DialogLoadingComponent } from '../../../shared/components/dialog-loading/dialog-loading.component'
import { SnackbarCustomService } from '../../../shared/components/snackbar/snackbar-custom.service'
import { ErrorRequestModel } from '../../../core/models/response.model'
import { responseDefaultForm } from '../../../shared/utils/utils'

@Component({
  selector: 'coordinator',
  imports: [
    MatCard,
    MatProgressBar,
    TableListComponent,
    CoordinatorCreateComponent,
    MatPaginatorModule,
    FormClientSearchComponent,
  ],
  templateUrl: './coordinator.component.html',
  styleUrl: './coordinator.component.scss',
  providers: [CoordinatorService, AuthService],
  standalone: true,
})
export class CoordinatorComponent implements OnInit {
  constructor(
    private coordenadorService: CoordinatorService,
    private authService: AuthService,
    private snackbar: SnackbarCustomService,
    private dialog: MatDialog,
  ) {}

  page = 1
  rows = 10
  numberRows = 0
  itemsList: any[] = []
  loading = false
  inputSearch: any = { type: '', search: '' }
  searchForm: any = { search: false, model: {} }

  listSearch: any = [
    { id: 'nome', description: 'Nome', type: 'string', visible: true },
    { id: 'contato', description: 'Contato', type: 'string', visible: true },
    { id: 'ativo', description: 'Ativo', type: 'string', visible: true },
  ]

  columns: any[] = [
    { keyColumn: 'name', key: 'nome', description: 'Nome' },
    { keyColumn: 'contact', key: 'contato', description: 'Contato' },
    {
      keyColumn: 'action',
      key: { edit: false, delete: false, active: false },
      description: 'Ações',
    },
  ]

  screen = 'coordenador'

  ngOnInit() {
    this.checkColumnAction()
    this.getListItems()
  }

  checkColumnAction() {
    const index = this.columns.findIndex((ele: any) => ele.keyColumn == 'action')
    if (index != -1) {
      this.columns[index].key = {
        edit: this.checkPermission('editar'),
        delete: false,
        active: true,
      }
      if (!Object.values(this.columns[index].key).includes(true)) {
        this.columns.splice(index, 1)
      }
    }
  }

  checkPermission(permission: string) {
    return this.authService.checkPermission(permission, this.screen)
  }

  uploadList(type: 'new' | '' = '') {
    if (type == 'new') {
      this.searchForm = { search: false, model: {} }
    }
    if (this.searchForm.search) {
      this.searchListItems()
    } else {
      this.getListItems()
    }
  }

  onPageEvent(event: PageEvent) {
    this.page = event.pageIndex + 1
    this.rows = event.pageSize
    this.uploadList()
  }

  search(event: any) {
    if (event.search) {
      this.searchForm = {
        search: true,
        model: this.createModel(event.data),
      }
    }
    this.page = 1
    this.uploadList(!event.search ? 'new' : '')
  }

  createModel(element: any) {
    const model: any = {}
    for (let i = 0; i < this.listSearch.length; i++) {
      const item = this.listSearch[i]
      model[item.id] =
        item.id == element.type
          ? element.search
          : responseDefaultForm(item.type)
    }
    return model
  }

  getListItems() {
    this.loading = true
    this.coordenadorService.listPagedCoordenador(this.page, this.rows).subscribe({
      next: (response: any) => {
        this.itemsList = response.data ?? []
        this.numberRows = response.totalItens
      },
      error: () => {
        this.itemsList = []
      },
      complete: () => {
        this.loading = false
      },
    })
  }

  searchListItems() {
    this.loading = true
    this.coordenadorService
      .searchPagedCoordenador(this.page, this.rows, this.searchForm.model)
      .subscribe({
        next: (response: any) => {
          this.itemsList = response.data ?? []
          this.numberRows = response.totalItens
        },
        error: () => {
          this.itemsList = []
        },
        complete: () => {
          this.loading = false
        },
      })
  }

  editItem(item: any) {
    const dialogRef = this.dialog.open(CoordinatorEditComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      data: { item },
    })
    dialogRef.componentInstance.responseEdit.subscribe((response: any) => {
      if (response) {
        this.uploadList()
      }
    })
  }

  deleteItem(item: any) {}

  activeItem(item: any) {
    const dialogRef = this.dialog.open(DialogLoadingComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      width: '400',
      data: {
        message: `Aguarde, ${item.ativo == 'S' ? 'desativando' : 'ativando'} coordenador.`,
        loading: true,
      },
    })
    const componentInstance = dialogRef.componentInstance
    this.coordenadorService
      .toggleCoordenador({
        id: item.id,
        ativo: item.ativo?.toLowerCase() == 's' ? 'N' : 'S',
      })
      .subscribe({
        next: (response: any) => {
          componentInstance.data.loading = false
          this.snackbar.success(response.message)
          dialogRef.close()
        },
        error: (err: ErrorRequestModel) => {
          dialogRef.close()
        },
        complete: () => {
          this.uploadList()
          dialogRef.close()
        },
      })
  }
}
